import { bindMethod, Sniff } from './chunk-QF7HVQZZ.js';
import { Delay, Raf } from './chunk-WILRAE77.js';

// src/resize.ts
var _ResizeHub = class {
  constructor() {
    this.subs = [];
    this.on = false;
    bindMethod(this, [
      "_raf",
      "_run",
      "_handler"
    ]);
    this.timer = new Delay(() => this._rafTrigger(), 40);
    window.addEventListener(
      Sniff.isMobile ? "orientationchange" : "resize",
      this._handler.bind(this)
    );
    this.raf = new Raf("resize hub", this._run.bind(this));
  }
  add(cb) {
    const id = /* @__PURE__ */ Symbol("resize");
    this.subs.push({ id, cb });
    return id;
  }
  remove(id) {
    const i = this.subs.findIndex((s) => s.id === id);
    if (i >= 0) this.subs.splice(i, 1);
  }
  _handler() {
    this.timer.run();
  }
  _rafTrigger() {
    if (!this.on) {
      this.on = true;
      this.raf.run();
    }
  }
  _run() {
    try {
      for (let i = 0; i < this.subs.length; i++) {
        this.subs[i]?.cb();
      }
    } finally {
      this.raf.stop();
      this.on = false;
    }
  }
};
var ResizeHub = new _ResizeHub();

export { ResizeHub };
//# sourceMappingURL=chunk-QXB7ANVF.js.map
//# sourceMappingURL=chunk-QXB7ANVF.js.map